import { FC } from 'react';
import { useTranslate } from 'hooks/useTranslate';

import { CustomMovement } from 'types';

import TableBody from 'modules/_shared/Table/components/TableBody';

import CustomMovementsSectionTableRow from './CustomMovementsSectionTableRow';
import { useCustomMovementsSection } from '../context/CustomMovementsSectionContext';

const CustomMovementsSectionTableBody: FC = () => {
  const { t } = useTranslate();

  const { data } = useCustomMovementsSection();

  const hasData = data.customMovements?.length > 0;

  const rows = data.customMovements!.map(
    (customMovement: CustomMovement, index: number) => (
      <CustomMovementsSectionTableRow
        key={customMovement._id ?? `custom-movement-row-${index}`}
        index={index}
        customMovement={customMovement}
      />
    )
  );

  return (
    <TableBody
      hasData={hasData}
      content={rows}
      noDataMessage={t('NoCustomMovements')}
    />
  );
};

export default CustomMovementsSectionTableBody;
